// extracted by mini-css-extract-plugin
export default {"Avatar":"Avatar_Avatar__2tt1y","LockShade":"Avatar_LockShade__HPTIt","Initials":"Avatar_Initials__niwis"};